import { NgModule } from "@angular/core";
import { Routes, RouterModule, mapToResolve } from "@angular/router";

import { BUILDER_ROUTES } from "./builder/builder.routes";
import { DASHBOARD_ROUTES } from "./dashboard/dashboard.routes";
import { FLOW_ROUTES } from "./flow/flow.routes";
import { AUTH_ROUTES } from "./auth/auth.routes";
//import { CASINGPLAN_ROUTES } from "./casingplans/casing-plan.routes";
import { GIS_ROUTES } from "./gis/gis.routes";
import { ADMIN_ROUTES } from "./admin/admin.routes";
import { EB_ROUTES } from "./entity-builder/entity-builder.routes";
import { PAYMENTS_ROUTES } from "./payments/payments.routes";
import { CORE_ROUTES } from "./core/core.routes";

import { COMMON_ROUTES } from "./common/common.routes";
import { ScrollContentComponent } from "./layouts/scroll-content.component";
import { REPORT_ROUTES } from "./reports/reports.routes";
import { ReportLayoutComponent } from "./layouts/report-layout.component";
import { LAW_LIBRARY_ROUTES } from "./law-library/law-library-routing.module";
import { HELP_LIBRARY_ROUTES } from "./help-library/help-library-routing.module";
import { LETTERS_ROUTES } from "./letters/letters.routes";
import { TEXT_TEMPLATES_ROUTES } from "./text-templates/text-templates.routes";
import { ON_BEHALF_ROUTES } from "./on-behalf/on-behalf-routing.module";
import { ISSUES_ROUTES } from "./issues/issues-routing.module";
import { APPLICATION_ROUTES } from "./applications/applications.routes";
import { NavResolver } from "./core/components/resolvers/nav.resolver";
import { AuthRequiredComponent } from "./core/components/auth-required.component";
import { CanDeactivateGuardService } from "./auth/guards/can-deactivate-guard.service";
import { SelectOrganizationComponent } from "./core/components/select-organization.component";
import { BaseGuardService } from "./auth/guards/base-guard.service";
import { MasterGuardService } from "./auth/guards/master-guard.service";

const routes: Routes = [
    { path: "auth", component: ScrollContentComponent, children: AUTH_ROUTES, resolve: { navigationItems: mapToResolve(NavResolver) } },    
    { path: "home", component: ScrollContentComponent, children: CORE_ROUTES, resolve: { navigationItems: mapToResolve(NavResolver) } },
    { path: '', redirectTo: "home/login", pathMatch: "full" },
    {
        path: '', resolve: { navigationItems: NavResolver }, children: [
            { path: "help-library", component: ScrollContentComponent, children: HELP_LIBRARY_ROUTES },
            { path: "law-library", component: ScrollContentComponent, children: LAW_LIBRARY_ROUTES },
            { path: "builder", component: ScrollContentComponent, children: BUILDER_ROUTES },
            { path: "dashboard", component: ScrollContentComponent, children: DASHBOARD_ROUTES },
            { path: "page", component: ScrollContentComponent, children: DASHBOARD_ROUTES },
            { path: "flow", component: ScrollContentComponent, children: FLOW_ROUTES },
            { path: "gis", component: ScrollContentComponent, children: GIS_ROUTES },
            { path: "admin", component: ScrollContentComponent, children: ADMIN_ROUTES },
            { path: "entitybuilder", component: ScrollContentComponent, children: EB_ROUTES },
            { path: "payment", component: ScrollContentComponent, children: PAYMENTS_ROUTES },
            { path: "common", component: ScrollContentComponent, children: COMMON_ROUTES },
            { path: "reports", component: ScrollContentComponent, children: REPORT_ROUTES },
            { path: "on-behalf", component: ScrollContentComponent, children: ON_BEHALF_ROUTES },
            { path: "letters", component: ScrollContentComponent, children: LETTERS_ROUTES },
            { path: "text-templates", component: ScrollContentComponent, children: TEXT_TEMPLATES_ROUTES },
            { path: "issues", component: ScrollContentComponent, children: ISSUES_ROUTES },
            { path: "applications", component: ScrollContentComponent, children: APPLICATION_ROUTES }
        ]
    },
    { path: "**", redirectTo: "home" }
];

@NgModule({
    imports: [
        RouterModule.forRoot(routes, { enableTracing: false })],
    exports: [RouterModule],
    providers: [CanDeactivateGuardService, MasterGuardService ]  
})

export class AppRoutingModule {

}